import { render, staticRenderFns } from "./politicsProjectFlow.vue?vue&type=template&id=90b36de4&scoped=true"
import script from "./politicsProjectFlow.vue?vue&type=script&lang=js"
export * from "./politicsProjectFlow.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectFlow.vue?vue&type=style&index=0&id=90b36de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b36de4",
  null
  
)

export default component.exports